<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Danh sách người theo dõi
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="messError">
                        <span>{{messError}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="btn-invite-partner">
                        <ButtonAddComponent :width="'250px'" :label="labelButtonSyncZalo" @click="syncZaloUser" ></ButtonAddComponent>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-between mt-4">
                        <div class="action d-flex align-items-center gap-3">
                            <div class="total">
                                {{ CommonText.TOTAL_RECORD(listUsersZalo.length, paginate.itemCount) }}
                            </div>
                        </div>
                        <div class="action-left d-flex align-items-center gap-3">
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectLimitPage.label"
                                        :id="selectLimitPage.id"
                                        :placeholder="selectLimitPage.placeholder"
                                        :value-default="selectLimitPage.value"
                                        :required="selectLimitPage.required"
                                        :options="selectLimitPage.options"
                                        @action="actionLimitPage($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <table class="table">
                            <thead>
                            <tr>
                                <th scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="listUsersZalo.length > 0" v-for="user in listUsersZalo" :key="user.id">
                                <td class="user-zalo-name"><p @click="showUserDetail(user.follower_id)">{{user.username ?? user.follower_id}}</p></td>
                                <td class="d-flex align-items-center justify-content-center" v-if="user.profile?.avatar"><div style="width: 120px; height: 120px"><img :src="user.profile?.avatar" alt="" style="width: 100%; height: 100%"></div></td>
                                <td class="d-flex align-items-center justify-content-center" v-else><div style="width: 120px; height: 120px"><IconImage :widthImage="'120'" :heightImage="'120'"></IconImage></div></td>
                                <td>{{user.profile?.user_is_follower ? 'Đang theo dõi' : 'Chưa theo dõi'}}</td>
                                <td>{{user.profile?.user_last_interaction_date ?? ''}}</td>
                                <td class="text-center" v-if="!user.partner"><ButtonAddComponent :width="'200px'" :label="'Gửi lời mời hợp tác'" @click="sendInviteCooperate(user.follower_id)"></ButtonAddComponent></td>
                                <td class="text-center" v-else-if="user.partner && user.partner.status === $AppConstant.PARTNER_STATUS_INVITE"><ButtonAddComponent :width="'200px'" :label="'Đã gửi lời mời'"></ButtonAddComponent></td>
                                <td class="text-center" v-else-if="user.partner && user.partner.status === $AppConstant.PARTNER_STATUS_CONNECTED"><ButtonAddComponent :width="'200px'" :label="'Đã hợp tác'" ></ButtonAddComponent></td>
                            </tr>
                            <tr v-else>
                                <td colspan="5" class="text-center">Không có dữ lệu được tìm thấy!</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <PaginateComponent v-if="listUsersZalo.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>
<ModalUserZaloDetailComponent
        @showModal="eventShowModal($event)"
        :eventClickShowModal="eventClickShowModal"
        :user="userDetail"
></ModalUserZaloDetailComponent>
<LoadingComponent v-if="isLoading"></LoadingComponent>